<template>
  <header class="main-header">
            <div class="top-header">
                <div class="container">
                    <form class="form-inline searchform" method="get" v-on:submit.prevent="searching">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control"  v-model="keyword" placeholder="歌曲名稱 / 作者" aria-describedby="basic-addon1">
                            <span class="input-group-btn" id="basic-addon1">
                            <button class="btn btn-primary" type="button" @click="searching"><i class="fa fa-search"></i></button>
                          </span>
                        </div>
                    </form>
                    <ul class="list-inline member-menu-login mb-0">
                        <li class="list-inline-item" v-if="!this.authorized">
                            <!-- <a class="btn btn-primary btn-sm" href="#" @click="login" title="會員登入">登入</a> -->
                            <a class="btn btn-primary btn-sm" href="#" data-toggle="modal" data-target="#loginpanel" title="會員登入">登入</a>
                              <!-- Modal -->
                              <div class="modal fade loginmodal loginmodal-vertical text-center" id="loginpanel"
                                   tabindex="-1" role="dialog"
                                   aria-labelledby="myModalLabel" aria-hidden="true">

                              	<div class="modal-dialog modal-md">
                              		<div class="modal-content">
                              			<div class="modal-header">
                              				<a href="#" class="close" data-dismiss="modal" aria-label="Close">
                              					<!-- <span class="remove"><i class="remove_i"></i></span> -->
                                        <span aria-hidden="true">&times;</span>
                              				</a>
                              				<h4 class="modal-title text-primary text-center" id="myModalLabel">會員登入</h4>
                              			</div>
                              			<div class="modal-body">
                          						<div class="fblogn">
                          							<h6 class="title title-loginform">臉書登入</h6>
                                        <button type="button" @click="fblogin" class="btn btn-fb btn-block">Facebook登入</button>
                          						</div>
                          						<h6 class="title title-loginform">一般登入</h6>
                          						<form role="form" class="loginform">
                          							<div class="input-group form-group">
                          								<span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                          								<input type="email" class="form-control" id="accountbox" placeholder="帳號/email" v-model="email">
                          							</div>
                          							<div class="input-group form-group">
                          								<span class="input-group-addon"><i class="fa fa-lock fa-lg"></i></span>
                          								<input type="password" class="form-control" id="passwordbox" placeholder="密碼" v-model="password">
                          							</div>
                          							<button type="button" @click="login" class="btn btn-primary btn-block">登入</button>
                          							<!-- <a href="#">忘記密碼？</a> -->
                          						</form>
                              			</div>
                              		</div>
                              	</div>

                              </div>
                        </li>
                        <li class="list-inline-item" v-if="!this.authorized">
                          <a class="btn btn-primary btn-sm" href="/register" title="會員註冊">註冊</a>
                        </li>
                        <li class="list-inline-item member-menu-text dropdown" v-if="this.authorized">
                            <a class="dropdown-toggle" href="/" id="memberCenter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{UserName}}</a>
                            <!-- <router-link v-bind:to="'/collection'">{{UserName}}</router-link> -->
                            <div class="dropdown-menu" aria-labelledby="memberCenter">
                                <a class="dropdown-item" :href="'/collection'">會員收藏</a>
                            </div>
                            歡迎回來
                            <button type="button" class="btn btn-primary btn-sm" @click="userLogout">登出</button>
                        </li>

                    </ul>
                </div>
            </div>

            <div class="container">
                <nav class="navbar navbar-toggleable-sm navbar-light">

                    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                          <span class="navbar-toggler-icon"></span>
                    </button>
                    <a class="navbar-brand main-logo" :href="'/'"><span>桅頂上</span></a>
                    <div class="collapse navbar-collapse main-menu" id="navbarCollapse">
                        <!-- <ul class="navbar-nav mr-auto mt-2 mt-md-0"> -->
                        <ul class="navbar-nav mt-2">
                            <li class="nav-item">
                                <router-link class="nav-link" v-bind:to="'/about'">緣起 <span class="sr-only">(current)</span></router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" v-bind:to="'/songsPick'">挑歌秘笈</router-link>
                            </li>
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="/" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">精選歌曲</a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                    <a class="dropdown-item" :href="'/songsCatalog'">分類說明</a>
                                    <a class="dropdown-item" :href="'/songCategory/1'">求婚/迎賓</a>
                                    <a class="dropdown-item" :href="'/songCategory/2'">新人進場</a>
                                    <a class="dropdown-item" :href="'/songCategory/3'">愛情故事回顧</a>
                                    <a class="dropdown-item" :href="'/songCategory/4'">婚宴配樂</a>
                                    <a class="dropdown-item" :href="'/songCategory/5'">送客/蜜月</a>
                                    <a class="dropdown-item" :href="'/topic'">特別企劃主題</a>
                                </div>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" :href="'/featured'">頂上故事</a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" :href="'/hot'">熱門話題</a>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" v-bind:to="'/contact'">聯絡我們</router-link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
</template>

<script>
/* eslint-disable */
import {mapActions, mapGetters} from 'vuex'
import Qs from 'qs'
export default {
  // props: ['userID'],
  name: 'topbar',
  data () {
    return {
      uri: this.$store.getters.getUri,
      name: '',
      email: '',
      password: '',
      app_id: '',
      keyword: '',
      authorized: false,
      routerPath: 'mainsearch'
    }
  },
  computed: {
    ...mapGetters({
      UserName: 'getUserName'
    })
  },
  created: function () {
    let token = window.localStorage.getItem('token')
    if (token === '' || token === 'null') {
      this.authorized = false
    } else {
      this.authorized = this.$store.getters.getAuth
    }
  },
  mounted: function () {
  },
  methods: {
    ...mapActions([
      'LOGIN',
      'LOGOUT'
    ]),
    userLogout () {
      this.$store.dispatch('LOGOUT').then(() => {
        this.authorized = false
        this.$router.push('/')
      })
    },
    onClickButton (event) {
      this.$emit('clicked', 'someValue')
    },
    getProfile () {
      let self = this
      FB.api('/me?fields=name,id,email', function (response) {
        // vm.$set(vm, 'name', response.name)
        let str = ''
	console.log(response)
        if (response.email === '' || typeof response.email === 'undefined') {
          str += '取得信箱失敗\n'
        } else if (response.id === '' || typeof response.id === 'undefined') {
          str += 'APP ID 錯誤\n'
        }
        if (str === '') {
          let data = Qs.stringify({
            app_id: response.id,
            email: response.email
          })
          self.$http.post(self.uri + 'User/fbLogin', data).then(function (res) {
            let data = res.data
            console.log(data)
            if (data.status === 200) {
              let userData = {
                userId: data.uid,
                userName: data.name,
                userEmail: data.email,
                token: data.token
              }
              self.$store.dispatch('LOGIN', userData).then(() => {
                self.authorized = true
                window.location.href = 'https://www.weddingsung.com/'
              })
            } else if (data.status === 510) {
              window.alert('取得資料失敗')
            }
          }).catch(function (error) {
            console.log(error)
          })
        } else {
          window.alert('基本資料取得錯誤')
        }
      })
    },
    fblogin () {
      let vm = this
      FB.login(function (response) {
        vm.statusChangeCallback(response)
      }, {
        scope: 'email, public_profile',
        return_scopes: true
      })
    },
    login () {
      let str = ''
      if (this.email === '' || typeof this.email === 'undefined') {
        str += '請輸入您的信箱\n'
      } else if (this.password === '' || typeof this.password === 'undefined') {
        str += '請輸入您的密碼\n'
      }
      if (str === '') {
        let self = this
        let data = Qs.stringify({
          email: this.email,
          password: this.password
        })
        this.$http.post(this.uri + 'User/Login', data).then(function (res) {
          let data = res.data
          if (data.status === 200) {
            let userData = {
              userId: data.uid,
              userName: data.name,
              userEmail: data.email,
              token: data.token
            }
            self.$store.dispatch('LOGIN', userData)
            self.authorized = true
          } else if (data.status === 204) {
              window.alert('帳號尚未註冊。')
          } else if (data.status === 510) {
            window.alert('登入失敗。')
          } else if (data.status === 403) {
            window.alert('查無此組帳號，請先進行註冊。')
          }
          self.$router.go('/')
        }).catch(function (error) {
          console.log(error)
        })
      } else {
        window.alert(str)
        return false
      }
    },
    statusChangeCallback (response) {
      let vm = this
      if (response.status === 'connected') {
        vm.getProfile()
      }
    },
    searching () {
      let keyword = this.keyword
      console.log('go where:' + this.$route.fullPath)
      let path;

      if (this.$route.fullPath !== '/') {
        path = this.$route.fullPath.split('/')
        this.routerPath = path[1]
      }
      console.log('key :' + this.routerPath)

      if (this.routerPath !== 'mainsearch') {
        this.$router.push({ path: `/mainsearch/${keyword}`})
      } else if (this.routerPath === 'mainsearch') {
        this.$router.push({ path: `/search/${keyword}`})
      }

      // this.$router.push({ path: 'search', query: { keyword: keyword }})
      // this.$router.go('/search/' + keyword)

      // this.$router.replace({ name: 'search',force: true, params: { key: keyword }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// Topbar.vue?750576db